export default [
    {
        device: 'desktop',
        minWidth: '768px',
    },
    {
        device: 'mobileXL',
        minWidth: '425px',
    },
    {
        device: 'mobileL',
        minWidth: '375px',
    },
    {
        device: 'mobileM',
        minWidth: '320px',
    },
    {
        device: 'mobileS',
        minWidth: '0',
    },
];
